import nl from './nl';

export default {
    nl
};
